// 单产品入口页面 mixin
import { mapState } from 'vuex';
export const indexMixin = {
  data() {
    return {
      disabledAll: false, //页面输入框状态
      //不需要获取职业code的产品
      unwantedGetProductCode: ['liansuo2021', 'HAGZZRX', 'PAHDLGZ', 'STARR_ZHUANGXIUBAO', 'pagongzesfB', 'pagongzesfA', 'PK07000148', 'ytgongzhong', '04014D', 'YTJGYQX', 'HAZXB', '11N00580', 'P060306', 'P07017201', 'pasfjgyqx', 'HACCZHX', 'MP18000783', 'MP18000963', 'GYBZXTY2022A', 'pazxttyw2018', 'MP1804037B', 'YQBYDWY', 'MP10040410', 'HT05HF', 'HT05I3', 'HT05HN', 'HAJGYQ'],
      // 需要根据计划获取职业code
      specialGetProductCode: []
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState({
      agreementRead: state => state.insureDoc.agreementRead //是否阅读告知书
    })
  },
  //生命周期 - 创建完成（可以访问当前this实例）期 - 销毁之前
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u; //用户id
    this.productCode = p; //产品code
    this.plan = planCode || p; //计划code
    if (this.$route.query.policyId) {
      //存在policyId 禁止输入框输入
      this.disabledAll = true;
    } else {
      this.disabledAll = false;
    }
    if (this.$route.query.xb) {
      //续保情况下释放输入框
      this.disabledAll = false;
    }
    this.$bus.$on('disabledBus', data => {
      //往下层组件存入 输入框状态
      this.disabledAll = data;
    });
    this.$store.commit('setagreementRead', this.disabledAll); //触发是否阅读客户告知书的方法
    this.$store.dispatch('checkUpload', { mdProductCode: p, _this: this }); //查询产品是否需要风险告知函
    this.$store.dispatch('getMaterial', { mdProductCode: p, webUserId: u, _this: this }); //获取客户告知书承包等投保文件
    if (this.unwantedGetProductCode.indexOf(p) < 0) {
      //责任险不需要职业code
      if (this.specialGetProductCode.indexOf(p) > -1) {
        this.$store.dispatch('getProductCode', { productCode: this.plan, _this: this }); //获取职业code 需要根据计划获取职业code
      } else {
        this.$store.dispatch('getProductCode', { productCode: this.productCode, _this: this }); //获取职业code
      }
    }
    this.$store.dispatch('getPayMethod', { userId: this.creator, productCode: this.productCode, _this: this }); //查询支付方式
  },
  mounted() {
    this.$store.dispatch('getAddresOptions'); //获取地址code
  },
  beforeDestroy() {
    this.$bus.$off('disabledBus');
  }
};
